/**
 * Layer assembly: schema version, module definitions (`modules`), and
 * `buildSystemLayers`, which walks the `moduleTable` in `columns.ts`.
 */

import { getLogger } from '@logtape/logtape';
import type { ModuleDefinition } from '#lib/apps/types.js';
import IconModuleAadt from '#lib/assets/modules/aadt.svg?raw';
import { buildModuleLayers } from '#lib/common/moduleTable.js';
import type { TLayer } from '#lib/types.js';
import {
	EAbleyLinksModule,
	EProduct,
	type ILinksFeature,
	type ILinksSystemLayers
} from './interfaces';
import { getVectorLayerSource, groupByModule } from '#lib/common/layers.js';
import { moduleTable } from './columns';

// GeoServer dataset this app owns; drives availability and layer filtering.
export const LINKS_DATASET = 'aadt';

const log = getLogger(['links', 'ableylinks', 'layers']);

export const modules: ModuleDefinition[] = [
	{ id: EAbleyLinksModule.core, label: 'Legend', icon: IconModuleAadt }
];

/** Returns null when product data is missing; the caller treats this as a system-data load failure. */
export function buildSystemLayers(appLayers: ILinksFeature[]): ILinksSystemLayers | null {
	const aadtLayers = groupByModule(appLayers, EProduct.AbleyLinks, LINKS_DATASET);
	if (!aadtLayers) return null;

	return buildModuleLayers(
		moduleTable,
		aadtLayers,
		(layerId, feature, def) =>
			getVectorLayerSource(layerId, feature, def.map.style as Partial<TLayer>, def.map.zIndex),
		log
	) as ILinksSystemLayers;
}
